import { Permission } from '@Models';
import { RootState, useAppSelector } from '@Store';
import config from '../../config';

// Single source of truth for agent availability: a bops-only feature gated by
// the access:agent permission. Used both to gate the data fetch (so users
// without the permission never hit the 401-prone endpoint) and the subsystem
// mount.
const useCanAccessAgent = (): boolean => {
  const permissions = useAppSelector((state: RootState) => state.authorization.permissions);
  return config.REACT_APP_FLAVOR === 'bops' && permissions.includes(Permission.AccessAgent);
};

export default useCanAccessAgent;
